<template>
    <a :href="link" v-text="text"></a>
</template>

<script>
export default {
  name: 'TextLink',
  props: {
    link: String,
    text: String,
  },
};
</script>
